import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import numeral from 'numeral';

import BlankState from '../../../components/BlankState';
import StatusMessages2 from '../../../components/StatusMessages2';

import simpleReactValidator from 'simple-react-validator';

import {
  fetchOtherRates,
  addOtherRates,
  updateOtherRates
} from '../../../actions/rates';

class OtherRatesForm extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;

    this.validator = new simpleReactValidator();
    this.state = {
      insurer: user.userInfo.insurer,
      filter: {
        insurer: user.userInfo.insurer
      },
      otherRate: {
        insurer: user.userInfo.insurer
      }
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    const { otherRate } = nextProps || {};
    const { userInfo } = this.props.user;

    if (otherRate) {
      this.setState({
        otherRate: {
          ...otherRate,
          insurer: userInfo.insurer
        }
      });
    }
  }

  onChange = e => {
    e.preventDefault();
    const { name, value } = e.target;

    this.setState({
      otherRate: {
        ...this.state.filter,
        ...this.state.otherRate,
        [name]: value
      }
    });
  };

  onChangeFilter = e => {
    e.preventDefault();
    const { name, value } = e.target;
    const { filter, otherRates } = this.state;

    this.setState({
      filter: {
        insurer: filter.insurer,
        [name]: value
      },
      otherRates: {
        insurer: filter.insurer,
        ...otherRates,
        [name]: value
      }
    });
  };

  selectFilterType = e => {
    this.setState({
      activeFilter: e.target.value
    });
  };

  onSubmit = e => {
    e.preventDefault();
    const { addOtherRates, updateOtherRates } = this.props;
    const { otherRate } = this.state;
    if (this.validator.allValid()) {
      this.validator.hideMessages();
      let handler = {};

      if (otherRate.hasOwnProperty('id')) {
        handler = updateOtherRates(this.state.otherRate);
      } else {
        handler = addOtherRates(this.state.otherRate);
      }

      handler.then(response => {
        this.props.fetchOtherRates({ insurer: this.state.insurer });
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { activeFilter } = this.state;
    const { rates, covers, brokers } = this.props;
    const {
      id,
      minimum_premium,
      transhipment,
      war_risk,
      warehousing
    } = this.state.otherRate;
    console.log(this.state);
    return (
      <form className="form-horizontal" onSubmit={this.onSubmit}>
        <div className="col-sm-11">
          <div className="col-sm-offset-4 col-sm-8">
            {rates.updateRatesLoading ? (
              <BlankState
                data={false}
                customMessage="Saving rates..."
                isDataLoading={rates.updateRatesLoading}
              />
            ) : (
              <div>
                {rates.errorMessageUpdateRates && !rates.updateRatesLoading ? (
                  <StatusMessages2
                    type="error"
                    message={
                      rates.errorMessageUpdateRates !== undefined
                        ? rates.errorMessageUpdateRates
                        : ''
                    }
                  />
                ) : null}
                {rates.success && !rates.updateRatesLoading ? (
                  <StatusMessages2 type="success" message="New rates saved" />
                ) : null}
              </div>
            )}
          </div>

          <div className="form-group">
            <label className="col-sm-4 control-label">Select Entity:</label>
            <div className="col-sm-8">
              <select
                name="filter"
                className="form-control"
                onChange={this.selectFilterType}
              >
                <option value="">- Filter by -</option>
                <option value="partnership">Broker Partnership</option>
                <option value="opencover">Open Cover</option>
              </select>
              {this.validator.message(
                'filter',
                activeFilter,
                'required',
                'text-danger'
              )}

              {activeFilter === 'partnership' ? (
                <select
                  name="intermediary_partnership"
                  className="form-control"
                  onChange={this.onChangeFilter}
                >
                  <option value="">- Select a Broker Partnership -</option>
                  {brokers.partners.map((partner, index) => {
                    return (
                      <option key={index} value={partner.id}>
                        {partner.intermediary_name}
                      </option>
                    );
                  })}
                </select>
              ) : null}
              {activeFilter === 'opencover' ? (
                <select
                  name="corporate_client"
                  className="form-control"
                  onChange={this.onChangeFilter}
                >
                  <option value="">- Select Open Cover -</option>
                  {covers.openCovers.map((cover, index) => {
                    return (
                      <option key={index} value={cover.company}>
                        {cover.company_name}
                      </option>
                    );
                  })}
                </select>
              ) : null}
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-4 control-label">Minimum Premium:</label>
            <div className="col-sm-8">
              <input
                type="number"
                name="minimum_premium"
                className="form-control"
                onChange={this.onChange}
                value={numeral(minimum_premium).value('0,0') || ''}
              />
              {this.validator.message(
                'minimum_premium',
                minimum_premium,
                'required',
                'text-danger'
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-4 control-label">Warehousing (%):</label>
            <div className="col-sm-8">
              <input
                type="number"
                min="1"
                name="warehousing"
                className="form-control"
                onChange={this.onChange}
                value={numeral(warehousing).value('0,0') || ''}
              />
              {this.validator.message(
                'warehousing',
                warehousing,
                'required|gt:1',
                'text-danger'
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-4 control-label">Transhipment (%):</label>
            <div className="col-sm-8">
              <input
                type="number"
                min="1"
                name="transhipment"
                className="form-control"
                onChange={this.onChange}
                value={numeral(transhipment).value('0,0') || ''}
              />
              {this.validator.message(
                'transhipment',
                transhipment,
                'required|gt:1',
                'text-danger'
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="col-sm-4 control-label">War Risk (%):</label>
            <div className="col-sm-8">
              <input
                type="number"
                mine="1"
                name="war_risk"
                className="form-control"
                onChange={this.onChange}
                value={numeral(war_risk).value('0,0') || ''}
              />
              {this.validator.message(
                'war_risk',
                war_risk,
                'required|gt:1',
                'text-danger'
              )}
            </div>
          </div>

          <div className="form-group">
            <div className="col-sm-8 col-sm-offset-4">
              {id ? (
                <button type="submit" className="btn btn-warning">
                  <i className="icon ion-edit" /> Update Rates
                </button>
              ) : (
                <button type="submit" className="btn btn-success">
                  <i className="icon ion-checkmark" /> Add Rates
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  brokers: state.brokers,
  covers: state.covers,
  rates: state.rates
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { fetchOtherRates, addOtherRates, updateOtherRates },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OtherRatesForm);



// WEBPACK FOOTER //
// ./src/pages/dashboard/rates/OtherRatesForm.jsx